import {Mapper} from '@s-ui/domain'

export class MakeLeadResponseToContactModelSellerResponseVO extends Mapper {
  constructor({contactModelSellerResponseValueObject}) {
    super()
    this._contactModelSellerResponseValueObject = contactModelSellerResponseValueObject
  }

  map = data => {
    const {createdMakeLeadId} = data

    return this._contactModelSellerResponseValueObject({
      leadId: createdMakeLeadId
    })
  }
}
